import React from 'react'
import {
  Container,
  Header,
  Modal,
  Button,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import SelectionSettingsForm from './SelectionSettingsForm.js'

class RequestSelection extends React.Component {
  // props: {mode, selection, selections, typePresets}
  state = {
    open: false,
    selection: null,
  }
  handleSubmit = (s) => {
    this.setState({
      selection: s,
      open: true,
    });
  }
  handleClose = () => {
    this.setState({open: false});
  }
  render() {
    return (
      <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
        <Header as='h1' style={{color: '#f2711c'}}>
          Request Selection from Others
        </Header>
        <p>
          You can ask someone else to create a selection and then share it with you.
        </p>
        <SelectionSettingsForm
          selections={this.props.selections}
          selection={this.props.selection}
          typePresets={this.props.typePresets}
          onSubmit={(id,s)=>{this.handleSubmit(s);}}
          submitButtonName='Compute Invitation URL'
        />

        <Modal
          open={this.state.open}
          onClose={this.handleClose}
          size='small'
        >
          <Modal.Header>Share URL</Modal.Header>
          <Modal.Content>
            <p>Share this invitation URL with your collaborator to have them create the selection.</p>
            <Link to={'/invite?json='+encodeURIComponent(JSON.stringify(this.state.selection))}>URL</Link>
          </Modal.Content>
          <Modal.Actions>
            <Button content='Done' onClick={this.handleClose}/>
          </Modal.Actions>
        </Modal>

        <Header as='h2'>What Next?</Header>
        <p>
          Copy the URL and share it with the person you want to ask to create the selection.
          When that person opens that URL, they will be asked to create the selection.
          When they are done, they can export their selection, and share it with you.
          They will do so by sending you another URL.
          Go there to import their selection, and you are ready to go.
        </p>
        <Header as='h2'>Sounds Complicated?</Header>
        <p>
          This web application does not store anything on the server.
          All your selections are stored in your local browser.
          This allows us to offer this application without having to administer
          any accounts or other user-generated information,
          and thereby to avoid any possible data protection issues.
          All we do is host a few static files: the web application itself.
        </p>
        <p>
          Thus, to collaborate, <strong>you</strong> will have to exchange information yourself.
          We enable that by converting the information into a JSON string,
          and embedding that in a URL.
          You do the communication by sending the URL to a collaborator
          (by email, chat, or whatever means you please).
          The URL will take the collaborator to a page of the app
          that will extract the information from the URL
          and store it in their browser.
        </p>
      </Container>
    );
  }
}

export default RequestSelection